export default "__VITE_ASSET__2df090cc__"